// See details-disclosure.js for why setup cannot live in the constructor:
// an element may be upgraded before its children are parsed.
class DetailsModal extends HTMLElement {
  connectedCallback() {
    this.init();
  }

  init() {
    if (this.initialised) return;

    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    const closeButton = this.querySelector('button[type="button"]');
    if (!this.detailsContainer || !this.summaryToggle || !closeButton) {
      this.initWhenParsed();
      return;
    }

    this.initialised = true;

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    closeButton.addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  initWhenParsed() {
    if (this.retryQueued) return;
    this.retryQueued = true;

    const retry = () => {
      this.retryQueued = false;
      this.init();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', retry, { once: true });
    } else {
      requestAnimationFrame(retry);
    }
  }

  isOpen() {
    return this.initialised && this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    if (!this.initialised) return;
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
